// extracted by mini-css-extract-plugin
module.exports = {"tabs":"ReportModalTab_tabs__27bRT","tabDisabled":"ReportModalTab_tabDisabled__3XAht","tabCheck":"ReportModalTab_tabCheck__2IEoC","content":"ReportModalTab_content__3d8fY"};